import React, {Component} from 'react';
import {Card, Col, Row} from 'reactstrap';
import {formatMoney} from "../../Applications/shared/shared";
import bg from "../../../components/SpearGauge/images/Spear_v06_SpearBG.png";
import {SpearGauge} from "../../../components/SpearGauge/SpearGauge";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';
const labelStatus = ["Not Started", "Working", "", "", "", "", "", "", "", "Submitted", "Enrolled"];

export default class IncentivesMgr extends Component {

  constructor(props) {
    super(props);
    this.state = {
      gauge: {}
    }
    this.loaded = true;
  }

  render() {
    if (!this.props.gauge) return null;
    const ytd = this.props.gauge || 0;

    const gaugeLevel = this.props.levels.filter((level) => {
      return level.showAmount > ytd * 1000;
    });

    let separatorLines = [
      ...this.props.levels.map((level) => ({display: level.display, val: level.showAmount}))
      // {display: "Incentive 1", val: 33},
      // {display: "Incentive 2", val: 67},
      // {display: "Incentive 3", val: 100}
    ];
    // console.log(separatorLines)

    // separatorLines.sort((a, b) => a.val - b.val);
    const maxVal = separatorLines[separatorLines.length - 1] && separatorLines[separatorLines.length - 1].val || 1;
    // console.log(maxVal)
    // console.log(separatorLines)
    separatorLines.forEach((line) => {
      line.val = Math.floor(line.val / maxVal * 10000) / 100
    })

    // console.log(separatorLines)

    const calcYTD = (total) => {
      if (total < 50) {
        total = total * 1000;
        return total
      } else if (total > 999) {
        total = total / 1000;
        return total
      }
      return total
    }

    // let gaugePercent = calcYTD((maxVal / 1000));
    // console.log(ytd, maxVal, ytd / (maxVal / 1000));
    let gaugePercent = maxVal > 1 ? ytd / (maxVal / 1000) * 100 : 0;
    // if (gaugeLevel.length > 0) {
    //   gaugePercent = ytd / gaugePercent;
    // }
    // console.log(gaugePercent)
    // console.log(ytd, gaugeLevel[0].showAmount, gaugePercent)
    const displayPercentageText = (percent) => {
      if (percent < 10) {
        return "You are on your way!";
      } else if (percent < 20) {
        return "Success doesn't just find you!";
      } else if (percent < 30) {
        return `Impossible means "I'm possible"`;
      } else if (percent < 40) {
        return "Sometimes later becomes never.";
      } else if (percent < 50) {
        return "Dream bigger!";
      } else if (percent < 60) {
        return "You can do it!";
      } else if (percent < 70) {
        return "Don't give up now!";
      } else if (percent < 80) {
        return "You are destined for greatness!";
      } else if (percent < 90) {
        return "Way to be an inspiration!";
      } else if (percent < 100) {
        return "Push yourself. Almost there!";
      } else {
        return "Now you're just showing off!"
      }
    }
    let levels = undefined;
    if (this.props.levels.length > 0) {
      levels = {steps: 5, spaced: maxVal / 5, money: true};
    }

    return (
      <Card style={{
        borderRadius: 10,
        backgroundImage: `url(${bg})`,
        backgroundSize: "contain",
        display: "flex"
      }}>
        <Row style={{height: 50}}>
          <Col xs={12} style={{textAlign: "center", height: 50}}>
            <h4 style={{color: "white", padding: 10, marginBottom: 0}}>Management<br/>Tip of The Spear&trade;</h4>
          </Col>
        </Row>
        <Row>
          <Col xl={6} md={12} style={{display: "block"}}>
            <div style={{textAlign: "center", fontWeigh: "bold", color: "white"}}>
              <SpearGauge separatorLines={separatorLines} lineInterval={levels}
                          value={gaugePercent}/>
              {`$${formatMoney(ytd >= 1000 ? ytd / 1000 : ytd)}${ytd >= 1000 ? "M" : "K"}`}
            </div>

            <div style={{width: "fit-content", marginLeft: "auto", marginRight: "auto"}}>
              {/*  {this.props.levels.map((level, index) => {*/}
              {/*    return <div key={index}>*/}
              {/*      {Number(level.showAmount) / 1000 > (ytd) ?*/}
              {/*        <Fragment>*/}
              {/*          <img src={unChecked} width="20px" height="20px"/>&nbsp;*/}
              {/*          <span>{level.display}</span>*/}
              {/*        </Fragment>*/}
              {/*        :*/}
              {/*        <Fragment>*/}
              {/*          <img src={checked} width="20px" height="20px"/>&nbsp;*/}
              {/*          <strong>{level.display}</strong>*/}
              {/*        </Fragment>*/}
              {/*      }*/}

              {/*    </div>*/}
              {/*  })}*/}
              {/*<div key={"motivation"}*/}
              {/*     style={{fontStyle: "italic", color: "white"}}>{displayPercentageText(gaugePercent)}</div>*/}
            </div>
          </Col>
          <Col xl={6} md={12}>
            <div style={{padding: 10, color: "white"}}>
              <table style={{fontSize: 10, width: "100%"}}>
                <tbody>
                {this.props.leaders.map((leader, index) => {
                  return <tr key={index}>
                    <td>{leader.AgentName}</td>
                    <td>${formatMoney(leader.ytd)}</td>
                  </tr>
                })}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </Card>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Incentives/IncentivesMgr.js